export default __webpack_public_path__ + "static/media/flechader.6b9e6d04.svg";